let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hYFVW")).then(() => parcelRequire('42xmY'));